export default __webpack_public_path__ + "static/sanificazione_-29301ec9fccc436461556bf030d5fb63.jpg";